import { actionTypes } from "./constants";
import {
  AREA_INFO_GET,
  CURRENT_TIME_GET,
  AUTHORIZE_MATERIAL_ALL_LIST_GET,
  SEARCH_GLOBAL_GET,
  COMMON_DEPT_ALL_GET,
  COMMON_USER_BY_DEPT_GET,
  COMMON_DOWNLOADING_FILE_GET,
  USER_AREA_INFO_GET,
  COMMON_MATERIAL_LIST_GET,
  COUNTRY_LIST_GET,
} from "../../fetch/url";
import {
  USER_REGISTER_POST,
} from 'src/config/url';
import { curl } from 'zh-common-modules';
import { get, post } from '../../fetch/fetch';

export const setIsMobile = data => ({
  type: actionTypes.SET_ISMOBILE,
  data
});

export const setMessage = data => ({
  type: actionTypes.SET_MESSAGE,
  data
});

export const setCurMenu = data => ({
  type: actionTypes.SET_CURMENU,
  data
});

export const setCurUrl = data => ({
  type: actionTypes.SET_CURURL,
  data
});

export const setProvince = data => ({
  type: actionTypes.SET_PROVINCE,
  data
});

export const setCity = data => ({
  type: actionTypes.SET_CITY,
  data
});

export const setCounty = data => ({
  type: actionTypes.SET_COUNTY,
  data
});

export const setInterMenuIndex = data => ({
  type: actionTypes.SET_INTER_MENU_INDEX,
  data
});

export const setIsWideSreen = data => ({
  type: actionTypes.SET_IS_WIDE_SCREEN,
  data
});

export const setCityListArray = (data, index) => ({
  type: actionTypes.SET_CITY_LIST_ARRAY,
  data,
  index,
});

export const setCountyListArray = (data, index) => ({
  type: actionTypes.SET_COUNTY_LIST_ARRAY,
  data,
  index,
});

export const ClearCountyListArray = (data, index) => ({
  type: actionTypes.CLEAR_COUNTY_LIST_ARRAY,
  data,
  index
});

export const toggleListShow = data => ({
  type: actionTypes.TOGGLE_LIST_SHOW,
  data
});

export const toggleSolutionListShow = data => ({
  type: actionTypes.TOGGLE_SOLUTION_LIST_SHOW,
  data
});

export const setCurrentTime = data => ({
  type: actionTypes.SET_CURRENT_TIME,
  data
});

export const setAuthMaterialList = data => ({
  type: actionTypes.SET_AUTH_MATERIAL_LIST,
  data
});

export const setCurrMenuPath = data => ({
  type: actionTypes.SET_CURR_MENU_PATH,
  data
});

export const setSearchGlobal = data => ({
  type: actionTypes.SET_SEARCH_GLOBAL,
  data
});

export const setAllDept = data => ({
  type: actionTypes.SET_ALL_DEPT,
  data
});

export const setUserByDept = data => ({
  type: actionTypes.SET_USER_BY_DEPT,
  data
});

export const setBefourLoginUrl = data => ({
  type: actionTypes.SET_BEFOUR_LOGIN_URL,
  data
});

export const getAreaList = (params, cb) => {
  return dispatch => {
    get(AREA_INFO_GET, params)
      .then(res => {
        if (res.success) {
          const data = res.content;
          cb?.(data);
          if (params.level === 'province') {
            dispatch(setProvince(data));
          } else if (params.level === 'city') {
            dispatch(setCity(data));
          } if (params.level === 'county') {
            dispatch(setCounty(data));
          }
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '获取区域列表失败！',
        }));
      });
  };
};

export const getAreaListArray = (params, cb) => {
  return dispatch => {
    if (!params.parentId) {
      if (params.level === 'city') {
        cb?.([]);
        dispatch(setCityListArray([]));
      } if (params.level === 'county') {
        cb?.([]);
        dispatch(setCountyListArray([]));
      }
    } else {
      get(AREA_INFO_GET, params)
        .then(res => {
          if (res.success) {
            const data = res.content;
            if (params.level === 'city') {
              dispatch(setCityListArray(data, params.index));
              cb?.(data, params.index);
            } if (params.level === 'county') {
              dispatch(setCountyListArray(data, params.index));
              cb?.(data, params.index);
            }
          }
        })
        .catch(() => {
          dispatch(setMessage({
            type: 'error',
            msg: '获取区域列表失败！',
          }));
        });
    }
  };
};

export const register = (params) => {
  return dispatch => {
    post(USER_REGISTER_POST, params)
      .then(res => {
        if (res.success) {
          dispatch(setMessage({
            type: 'success',
            msg: res.message,
          }));
        }
      })
      .catch(() => {
        dispatch(setMessage({
          type: 'error',
          msg: '添加失败！',
        }));
      });
  };
};

export const getCurrentTime = (params) => {
  return dispatch => {
    get(CURRENT_TIME_GET, params)
      .then(res => {
        if (res.success) {
          const { content = {} } = res;
          const { time } = content;
          dispatch(setCurrentTime(time));
        }
      });
  };
};

export const getAuthorizeMaterial = (params, cb) => {
  return dispatch => {
    curl
      .get(AUTHORIZE_MATERIAL_ALL_LIST_GET, params)
      .then(res => {
        dispatch(setAuthMaterialList(res));
        cb?.(res);
      });
  };
};

export const getSearchGlobal = (params) => {
  return dispatch => {
    curl
      .get(SEARCH_GLOBAL_GET, params)
      .then(res => {
        dispatch(setSearchGlobal(res));
      });
  };
};

export const getAllDept = (params) => {
  return dispatch => {
    curl
      .get(COMMON_DEPT_ALL_GET, params)
      .then(res => {
        dispatch(setAllDept(res));
      });
  };
};

export const getUserByDept = (params) => {
  return dispatch => {
    curl
      .get(COMMON_USER_BY_DEPT_GET, params)
      .then(res => {
        dispatch(setUserByDept(res));
      });
  };
};

export const getDownloadingFileList = (params, cb) => {
  return dispatch => {
    curl
      .get(COMMON_DOWNLOADING_FILE_GET, params)
      .then(res => {
        cb?.(res);
      });
  };
};

export const getUserAreaList = (params, cb) => {
  return dispatch => {
    curl
      .get(USER_AREA_INFO_GET, params)
      .then(res => {
        cb?.(res);
      });
  };
};

export const getAllCountryList = (params, cb) => {
  return dispatch => {
    curl
      .get(COUNTRY_LIST_GET, params)
      .then(res => {
        cb?.(res);
      });
  };
};

/**
 * 获取物料列表分页
 * @param {*} params 参数
 * @param {*} cb 回调
 * @returns
 */
export const getMaterialList = (params, cb) => {
  return dispatch => {
    curl
      .get(COMMON_MATERIAL_LIST_GET, params)
      .then(res => {
        cb?.(res);
      });
  };
};
